import * as yup from "yup";
export const ScrumlineItemSchema = yup.object().shape({
  eid: yup.string(),
  scrumUpdate: yup.string(),
  present: yup.boolean(),
  absent: yup.boolean(),
});

export const ScrumSystemSchema = yup.object().shape({
  title: yup.string(),
  date: yup.string(),
  conductMetting: yup.string(),
  depName: yup.string(),
  demoUpdates: yup.string(),
  lineItems: yup.array().of(ScrumlineItemSchema),
});
